document.addEventListener('DOMContentLoaded', () => {
  if (!document.getElementById('article-product-card-style')) {
    const style = document.createElement('style');
    style.id = 'article-product-card-style';
    style.textContent = `
  [data-article-product-card] .product-card__title a {
    text-decoration: none !important;
  }
  [data-article-product-card] .product-card__title {
    margin: 0 !important;
  }
  [data-article-product-card] img {
    border-radius: 0 !important;
    border: none !important;
    box-shadow: none !important;
    margin-bottom: 0 !important;
  }
  [data-article-product-card] .product-card {
    overflow: hidden !important;
    border-radius: var(--pcard-radius) !important;
  }
  [data-article-product-card] .product-card__image-wrapper {
    border-radius: 0 !important;
  }
  [data-article-product-card] .btn--primary {
    background-color: #006666 !important;
    border-color: #006666 !important;
    color: #fff !important;
  }
`;
    document.head.appendChild(style);
  }

  document.querySelectorAll('[data-article-product-card]').forEach(async (el) => {
    const handle = el.dataset.handle;
    if (!handle) return;
    try {
      const res = await fetch(`/products/${handle}?view=article-card`);
      if (!res.ok) throw new Error(`Produkt "${handle}" nicht gefunden`);
      const html = await res.text();
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const card = temp.querySelector('.product-card');
      if (!card) throw new Error('Karte nicht im Response gefunden');
      el.innerHTML = '';
      el.appendChild(card);
    } catch (err) {
      console.error('Produktkarte konnte nicht geladen werden:', err);
      el.remove();
    }
  });
});